module.exports = __webpack_public_path__ + "static/media/and_scr_share_dialog.f944597f.png";